import { lighten } from '@material-ui/core/styles/colorManipulator';
import {colorPrimary} from '../../../utils/setting';

export const styles = theme => ({
    root: {
        marginTop: theme.spacing(3),
        position: 'relative',
        overflow: 'hidden',
        width: '100%'
        // padding: `${theme.spacing(3)}px ${theme.spacing(2)}px`,
    },
    container: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(3),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        [theme.breakpoints.down('md')]: {
            padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
        },
    },
    containerPaper:{
        display: 'flex',
        height: '100%'
    },
    infoTitle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '0.89rem'
    },
    formControl: {
        width: '100%',
        boxSizing: 'border-box',
        padding: theme.spacing(2),
    },
    row_info:{
        display: 'flex',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        textTransform: 'capitalize',
    },
    colStatus: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center'
    },
    square: {
        marginRight: '1rem',
        width: '1.2rem',
        height: '1.2rem',
        minWidth: 24,
        minHeight: 24,
    },
    square_checking: {
        backgroundColor: 'rgb(251, 140, 0)',
    },
    square_missed: {
        backgroundColor: '#aea7a7',
    },
    square_cancel: {
        backgroundColor: '#d03535',
    },
    square_confirm: {
        backgroundColor: '#2d94b2',
    },
    square_success: {
        backgroundColor: '#82c14d',
    },
    textField: {
        width: '100%'
    },
    input_datepicker: {
        marginTop: '0px',
        marginBottom: '0px',
    },
    toDate: {
        textAlign: 'right',
        [theme.breakpoints.down('sm')]: {
            textAlign: 'left',
        },
    }
})

export const toolbarStyles = theme => ({
    titleText: {
      fontSize: '1.11rem',
    },
    root: {
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
        boxSizing: 'border-box',
        backgroundColor: 'rgba(41, 47, 72, 0.85)',
        color: '#fff',
        [theme.breakpoints.up('md')]: {
            minHeight: theme.spacing(7)
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: theme.spacing(7)
        },
    },
    label: {
        width: '20%'
    },
    containerInput: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    inputBase: {
        marginLeft: theme.spacing(1),
        color: theme.palette.text.secondary,
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: '#f4f4f4',
        '&:hover': {
            backgroundColor: '#f4f4f4',
        },
        marginLeft: theme.spacing(2),
        marginRight: 0,
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: '80%',
    },
    title: {
        flex: '0 0 auto',
        color: '#fff'
    },
});